import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { AnyInnerSection, InnerSection, InnerSectionAttributes, Section, SectionAttributes } from '../../types/section';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { DownloadLinkComponent } from '@knorr-bremse-portals/ngx-components/components/download-link';
import { ColumnListComponent } from '@knorr-bremse-portals/ngx-components/components/column-list';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

export interface DownloadListAttributes extends SectionAttributes {
  numColumns: 4 | 6 | 12;
  headline: string;
  items: DownloadFileSection[];
  parentNumColumns?: number;
}

type DownloadListEditorIds = [
  'headline',
  'items',
  'noMarginBottom',
  'smallBreakpointMoveToBottom',
  'smallBreakpointReverseOrder',
]

export type DownloadListSection = Section<DownloadListAttributes, DownloadListEditorIds, 'download-list'>;

export function isDownloadListSection(section: AnyInnerSection): section is DownloadListSection {
  return section.component === 'download-list';
}

interface DownloadFileSectionAttributes extends InnerSectionAttributes {
  url: string;
  type: typeof DownloadLinkComponent.prototype.fileType;
  label: string;
  size?: number;
  target: string;
}

type DownloadFileEditorIds = [
  'url',
  'type',
  'label',
  'size',
  'target',
];

export type DownloadFileSection = InnerSection<DownloadFileSectionAttributes, DownloadFileEditorIds, 'download-file'>;

@Component({
    selector: 'app-download-list',
    styleUrls: ['./download-list.component.scss'],
    templateUrl: './download-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        DownloadLinkComponent,
        ColumnListComponent,
        RouterOrExternalLinkDirective,
        FsButtonComponent,
    ],
})
export class DownloadListComponent extends SectionComponent<DownloadListSection> {
}
